import ApiService from "@/services/api.service";

const route = 'standard-imports';

const standardImports = {
    add(_module) {
        return new Promise((resolve, reject) => {            
            ApiService.post(route, _module).then(({ data}) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    }
};

export default standardImports;